import React, {useState, useEffect} from 'react';
import {config} from "../../config";
import {handleResponse} from "../../helpers/response";
import { Link } from "react-router-dom";
import i18n from "i18next";
import loader from "../../images/loader.svg";

const CustomMenu = ()=>{
    const [menuFilters, setMenuFilters] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    useEffect( ()=>{
        var link = config.apiUrl + 'api/get/custommenu/'+i18n.language;
        fetch(link, {method: 'GET' }).then(handleResponse).then(json => {
            setMenuFilters( json );
            setShowLoader(false);
        }).catch( error =>{alert("error")});
    },[] )
    return (<>
        {/* {showLoader&&"...loading"} */}
        <li className={showLoader ? "menu-loader uk-position-relative " : "uk-hidden"}>
            <div className="loader-overlay  uk-position-z-index">
                  <div className="uk-position-center">
                    <img className="loader-img" src={loader} uk-svg={""} alt={"loading..."} />
                  </div>
            </div>
        </li>
        {Object.keys(menuFilters).map(id=>{
            return <li key={id}><Link className='header-nav__link' to={`/products/${i18n.language}/cat/${id}`}>{menuFilters[id].name}</Link></li>
        }) }
    </>);
}
export default CustomMenu;